import React, { useState, useEffect } from 'react';
import { 
  Container, 
  Paper, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  IconButton, 
  Button, 
  Typography,
  Box,
  Tooltip
} from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Edit, Delete, Check } from '@mui/icons-material';
import { ScrollableContent, ScrollWrapper } from '../Pedidos';
import { StyledTableCell, StyledTableRow } from '../Pedidos/components/acesso/acessoIndex';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import api from '../../Api/apiAxios';

const validationSchema = Yup.object({
  descricaoMotivo: Yup.string().required('Descrição do motivo é obrigatória')
});

export function MotivoCancelamento() {
  const [motivosCancelamento, setMotivosCancelamento] = useState([{ id: null, descricaoMotivo: '' }]);
  const [editIndex, setEditIndex] = useState(null);

  async function loadData() {
    const response = await api.get('MotivoCancelamento/');
    setMotivosCancelamento(response.data);
  }

  useEffect(() => {
    loadData();
  }, []);

  const formik = useFormik({
    initialValues: { descricaoMotivo: '' },
    validationSchema,
    onSubmit: async (values) => {
      if (editIndex !== null) {
        const id = motivosCancelamento[editIndex].id;

        if (id !== 0) {
          await api.put(`/MotivoCancelamento/`, { id: id, descricaoMotivo: values.descricaoMotivo });
        } else {
          await api.post('/MotivoCancelamento/', { id: 0, descricaoMotivo: values.descricaoMotivo });
        }

        loadData();
        setEditIndex(null);
        formik.resetForm();
      }
    }
  });

  const handleEdit = (index) => {
    setEditIndex(index);
    formik.setFieldValue('descricaoMotivo', motivosCancelamento[index].descricaoMotivo);
  };

  const handleDelete = async (id) => {
    await api.delete(`/MotivoCancelamento/${id}`);
    setMotivosCancelamento(motivosCancelamento.filter(m => m.id !== id));
  };

  const handleAddMotivo = () => {
    setMotivosCancelamento([...motivosCancelamento, { id: 0, descricaoMotivo: '' }]);
    setEditIndex(motivosCancelamento.length);
    formik.setFieldValue('descricaoMotivo', '');
  };

  return (
    <Container sx={{ mt: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pt: 1 }}>
        <Typography variant="h5" gutterBottom>
          Motivos de Cancelamento
        </Typography>

        <Button
          variant="text"
          sx={{ height: '2.5rem', fontSize: '0.78rem', color: 'rgb(19, 35, 80)', display: 'flex', alignItems: 'end' }}
          onClick={handleAddMotivo}
        >
          <AddCircleIcon sx={{ marginRight: '0.5rem' }} />
          Novo Motivo
        </Button>
      </Box>

      <ScrollWrapper component={Paper} elevation={2} sx={{ marginY: 1 }}>
        <ScrollableContent sx={{ width: '101.7%' }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCell>ID</StyledTableCell>
                  <StyledTableCell>Descrição do Motivo</StyledTableCell>
                  <StyledTableCell align="right">Ações</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {motivosCancelamento.map((motivo, index) => (
                  <StyledTableRow key={motivo.id}>
                    <TableCell>{motivo.id || '-'}</TableCell>
                    <TableCell>
                      {editIndex === index ? (
                        <form onSubmit={formik.handleSubmit}>
                          <input
                            type="text"
                            name="descricaoMotivo"
                            value={formik.values.descricaoMotivo}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className="form-control"
                          />
                          {formik.touched.descricaoMotivo && formik.errors.descricaoMotivo ? (
                            <div>{formik.errors.descricaoMotivo}</div>
                          ) : null}
                        </form>
                      ) : (
                        motivo.descricaoMotivo
                      )}
                    </TableCell>
                    <TableCell align="right">
                      {editIndex === index ? (
                        <Tooltip title='Salvar'>
                          <IconButton onClick={formik.handleSubmit}>
                            <Check color='success' />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        <>
                          <Tooltip title='Editar'>
                            <IconButton onClick={() => handleEdit(index)}>
                              <Edit style={{ color: '#ffc107' }}/>
                            </IconButton>
                          </Tooltip>
                          <Tooltip title='Deletar'>
                            <IconButton onClick={() => handleDelete(motivo.id)}>
                              <Delete color='error' />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}
                    </TableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </ScrollableContent>
      </ScrollWrapper>
    </Container>
  );
}
